import {Plugins, TypeImplementation} from '@packages/systems/wfdl';
import {BooleanTag} from '@packages/systems/plugins-utils/Boolean';
import {
  functionOf,
  TGeneric,
  TTypeApplication,
  TTypeConstructor,
  TTypeReference,
} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {ConditionalConfiguration} from './ConditionalConfiguration';
import {ConditionalSettings} from './ConditionalSettings';

const TConditionalConfiguration = TTypeConstructor(
  qualify(Plugins.name('Conditionals'), typeName('Configuration'))
);

export const plugin = Plugins.PrivilegedPlugin({
  dataTypes: {
    Configuration: ConditionalConfiguration,
    GenericConditional: TypeImplementation.Alias({
      params: ['x'],
      type: TTypeReference('x'),
      render: ConditionalSettings,
    }),
  },
  values: {
    Conditional: {
      envType: {
        dataType: TGeneric({
          arg: 'x',
          body: functionOf(
            TTypeApplication({
              con: TConditionalConfiguration,
              arg: TTypeReference('x'),
            }),
            TTypeApplication({
              con: TTypeConstructor(
                qualify(
                  Plugins.name('Conditionals'),
                  typeName('GenericConditional')
                )
              ),
              arg: TTypeReference('x'),
            })
          ),
        }),
        exported: 'hidden',
        preferTypeBindUI: true,
      },
      value: function conditional(config: {
        rules: Array<{
          condition: BooleanTag;
          output: unknown;
        }>;
        fallback: unknown;
      }): unknown {
        const rule = config.rules.find((x) => x.condition.tag === 'True');
        return rule ? rule.output : config.fallback;
      },
    },
  },
});
